<template>
  <div class="relative">
      <table v-if="items.length" class="base-table" :class="classes">
        <thead>
          <tr class="text-left">
            <th
              v-for="(field, index) in fields"
              :key="index"
              class="text-xs text-gray-dark font-normal py-2 relative"
              :class="{ 'text-center' : field.centered }"
            >
              {{ field.label }}
            </th>
            <th v-for="(action, index) in actions" :key="'action' + index" class="px-3 py-2" />
          </tr>
        </thead>
        <tbody
          :list="items"
          tag="tbody"
        >
          <template v-for="(item, index) in items">
            <tr :key="index" class="border cursor-default hover:bg-gray-light">
              <td 
                v-for="(field, _index) in fields" 
                :key="field.key + _index" 
                :class="[field.class, cellClasses, getCellClasses(field)]" 
                class="py-4 first:pl-4 first:border-l border-t border-b border-gray-200 align-top last:border-r" 
                @click="$emit('on-row-click', item)">
                <slot :name="getCellSlotName(field)" :item="item">
                  <span class="text-sm font-normal">{{ getItemValue(field, item) }}</span>
                </slot>
                <slot :item="item" :field="field" :index="_index" />
              </td>
              <td v-for="(action, actionIndex) in actions" :key="'actionIndex' + actionIndex" class="w-6 p-1 last:pr-4 border-t border-b last:border-r align-top py-4">
                <slot :name="getActionSlotName(action)" :action="action">
                      <i 
                        class="cursor-pointer icon text-lg" :class="'icon-' + action.icon"
                        v-if="canShowAction(action, item)"
                        @click="$emit(`on-${action.name}`, {item, id: item.id, index})"  
                      />
                </slot>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    <Button
      v-if="pagination"
      class="mt-4 is-blue-light"
      @click="$emit('get-more')"
    >
      Voir plus
    </Button>
    <slot name="pagination" :items="items">
      <div v-if="!items.length" class="mt-2 absolute top-0 left-0 w-full" :data="items" :loading="loading">{{ noResultLabel }}</div>
    </slot>
  </div>
</template>

<script>

import { resolveValue } from '../helpers/utils'

export default {
  props: {
    classes: {
      type: String,
      default: ''
    },
    cellClasses: {
      type: [String, Array],
      default: ''
    },
    fields: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    blankValue: {
      type: String,
      default: '-'
    },
    noResultLabel: {
      type: String,
      default: 'Pas de résultats'
    }
  },
  methods: {
    getCellSlotName: (field) => {
      return `cell(${field.key})`
    },
    getItemValue (field, item) {
      return resolveValue(item, field.key, this.blankValue)
    },
    getActionSlotName: (action) => {
      return `action(${action.name})`
    },
    getCellClasses (field) {
      return {
        'text-center': field.centered
      }
    },
    canShowAction (action, item) {
      if (action.hasOwnProperty('condition')) {
        return action.condition(item)
      }
      return true
    }
  }
}
</script>

<style scoped>

</style>
